import { Route } from '@angular/router';
import { HomeComponent, ProfileComponent } from '@features/homepage-components';
import { ApplicationManagerRoutingModule } from 'application-manager';
import { adminRoutes } from './admin.routes';

/** anyone signed in can access home */
export const homeRoutes: Route[] = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
    title: 'Home - DemandScience',
    data: {
      title: 'Home',
      tabTitle: 'Home - DemandScience',
    },
  },
  {
    path: 'profile',
    title: 'Profile - DemandScience',
    component: ProfileComponent,
    // loadComponent: () => import('@features/homepage-components').then(mod => mod.ProfileComponent),
    data: {
      title: 'Profile',
      tabTitle: 'Profile - DemandScience',
    },
  },
  adminRoutes,
  {
    path: '',
    loadChildren: () => ApplicationManagerRoutingModule,
  },
];
